export const environment = {
    production: false,
    baseUrl: 'https://kempeundco.pythonanywhere.com'
  };
  